import { gql } from '@apollo/client';

export const QUERY_PICKUP_CUSTOMER_OPTIONS = gql`
  query QueryPickupCustomerOptions {
    queryPickupCustomerOptions {
      id
      name
    }
  }
`;
